export default "__VITE_ASSET__BH3Zcyb$__"